<!-- <iframe [src]="iframe|safe: 'resourceUrl'" frameborder="0"></iframe> -->

<div class="contenedor">
  <div class="blanco">
    <div class="izquierda">
      <img src="assets/img/bellotas.png" alt="" />
    </div>
    <div class="centro"></div>
    <div class="derecha"></div>
  </div>
  <div class="videocontendedor">
    <div class="izquierdavideo">
      <img src="assets/img/university-logo.jpg" alt="" />
    </div>
    <div #scriptContainer class="video">
      <!-- <div id="web-player-0"></div> -->
      <div [(id)]="'rec-live-' + idSala"></div>
    </div>
    <div class="derechavideo">
      <img src="assets/img/university-logo.jpg" alt="" />
    </div>
  </div>
  <div class="blanco">
    <div class="izquierda"></div>
    <div class="centro"></div>
    <div class="derecha">
      <img src="assets/img/bellotas.png" alt="" />
    </div>
  </div>
</div>